var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAstropay = function SvgAstropay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h256v256H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.237 75 60 231h31.337l15.042-45.54h43.21L165.072 231H197L143.69 75h-30.453ZM143 160h-28l11.642-34.057a126.05 126.05 0 0 0 2.21-6.943c.737 2.339 1.474 4.75 2.359 7.162L143 160Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.798 85.018c20.562-20.888 55.377-33.39 93.23-33.39 14.72 0 29.13 1.863 42.681 5.59l1.09.311 24.301-7.3-10.904-4.115C184.478 38.194 160.646 34 136.111 34c-35.516 0-68.695 8.542-93.463 24.073L40 59.78 50.203 89.6l4.595-4.582Z",
    fill: "#FFF"
  }))));
};
export default SvgAstropay;